export default "__VITE_ASSET__DpskWfVR__"